// Relative time formatting — "2 hours ago", "3 days ago"

const MINUTE = 60
const HOUR = 3600
const DAY = 86400
const WEEK = 604800

export function formatRelativeTime(isoDate: string): string {
  const now = Date.now()
  const then = new Date(isoDate).getTime()
  const seconds = Math.floor((now - then) / 1000)

  if (seconds < 60) return 'just now'
  if (seconds < HOUR) {
    const m = Math.floor(seconds / MINUTE)
    return `${m}m ago`
  }
  if (seconds < DAY) {
    const h = Math.floor(seconds / HOUR)
    return `${h}h ago`
  }
  if (seconds < WEEK) {
    const d = Math.floor(seconds / DAY)
    return `${d}d ago`
  }
  return new Date(isoDate).toLocaleDateString(undefined, {
    month: 'short', day: 'numeric',
  })
}
